import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/project/:cid',
    name: 'Project',
    component: () => import('../views/project/Index.vue'),
    children: [
      {
        path: '',
        name: 'ProjectHome',
        component: () => import('../views/project/Home.vue')
      },
      {
        path: 'list/:pid',
        name: 'List',
        component: () => import('../views/project/List.vue')
      }
    ]
  },
  {
    path: '/battle/:cid',
    name: 'Battle',
    component: () => import('../views/battle/Index.vue')
  },
  {
    path: '/battle/:cid/:aid',
    name: 'Battle',
    component: () => import('../views/battle/Index.vue')
  },
  {
    path: '/international/:cid',
    name: 'International',
    component: () => import('../views/international/Index.vue')
  },
  {
    path: '/international/:cid/:aid',
    name: 'International',
    component: () => import('../views/international/Index.vue')
  },
  {
    path: '/info/:cid',
    name: 'Info',
    component: () => import('../views/info/Index.vue')
  },
  {
    path: '/info/:cid/:aid',
    name: 'Info',
    component: () => import('../views/info/Index.vue')
  },
  {
    path: '/partners/:cid/:aid',
    name: 'partners',
    component: () => import('../views/partners/Index.vue')
  },
  {
    path: '/media/:cid',
    name: 'media',
    component: () => import('../views/media/Index.vue'),
    children: [
      {
        path: '',
        name: 'news',
        component: () => import('../views/media/news.vue')
      },
      {
        path: 'videolist',
        name: 'videolist',
        component: () => import('../views/media/videoList.vue')
      },
      {
        path: '/video/:aid',
        name: 'Video',
        component: () => import('../views/media/Video.vue')
      }
    ]
  },
  
  {
    path: '/about/:cid',
    name: 'media',
    component: () => import('../views/about/Index.vue'),
    children: [
      {
        path: '',
        name: 'Brief',
        component: () => import('../views/about/Brief.vue')
      },
      {
        path: 'constitution',
        name: 'Constitution',
        component: () => import('../views/about/Constitution.vue')
      },
      {
        path: 'organization',
        name: 'Organization',
        component: () => import('../views/about/Organization.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('../views/about/Contact.vue')
      }
    ]
  },
  {
    path: '/article/:aid',
    name: 'Article',
    component: () => import('../views/Article.vue')
  },
  {
    path: '/search/:searchValue',
    name: 'search',
    component: () => import('../views/media/search')
  },
]

const router = new VueRouter({
  mode: 'history',
  // base: '/puji/',
  routes,
  scrollBehavior (to, from) {
    if (to.fullPath.indexOf('getLaw') >= 0 || to.fullPath.indexOf('getPartners') >= 0 || to.fullPath.indexOf('getJoin') >= 0) {
      return { x: 0, y: 0 }
    }
    if (from.name !== to.name) {
      if (from.fullPath.indexOf('about') < 0 || to.fullPath.indexOf('about') < 0) {
        return { x: 0, y: 0 }
      }
    }
  }
})

export default router
